import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const SEEN_KEY = "epc_seen_notifications";

function loadSeen() {
  try { return JSON.parse(localStorage.getItem(SEEN_KEY) || "[]"); } catch { return []; }
}
function markSeen(id) {
  const seen = loadSeen();
  if (!seen.includes(id)) {
    seen.push(id);
    localStorage.setItem(SEEN_KEY, JSON.stringify(seen.slice(-200)));
  }
}

export default function NotificationPopup() {
  const { user } = useAuth();
  const [queue, setQueue] = useState([]);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    if (!user) return;
    let mounted = true;
    api.get("/notifications/active").then((r) => {
      if (!mounted) return;
      const seen = loadSeen();
      const fresh = (r.data || []).filter((n) => !seen.includes(n.id));
      setQueue(fresh);
    }).catch(() => {});
    return () => { mounted = false; };
  }, [user]);

  useEffect(() => {
    if (!current && queue.length > 0) {
      setCurrent(queue[0]);
      setQueue((q) => q.slice(1));
    }
  }, [queue, current]);

  const dismiss = () => {
    if (current) markSeen(current.id);
    setCurrent(null);
  };

  if (!current) return null;

  return (
    <Dialog open={!!current} onOpenChange={(o) => { if (!o) dismiss(); }}>
      <DialogContent className="max-w-md p-0 overflow-hidden" data-testid="notification-popup" onInteractOutside={(e) => { /* allow outside click to dismiss */ }}>
        {current.image_url && (
          <div className="relative w-full aspect-[16/10] bg-slate-100">
            <img
              src={current.image_url}
              alt={current.title}
              className="w-full h-full object-cover"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
          </div>
        )}
        <div className="p-5">
          <DialogHeader>
            <DialogTitle className="font-display text-xl tracking-tight">{current.title}</DialogTitle>
          </DialogHeader>
          {current.message && (
            <p className="text-sm text-slate-600 mt-2 whitespace-pre-wrap">{current.message}</p>
          )}
          <DialogFooter className="mt-5">
            {current.cta_url && current.cta_label && (
              <a href={current.cta_url} target="_blank" rel="noreferrer">
                <Button className="bg-brand-gradient hover:opacity-90 text-white rounded-full px-5" data-testid="notif-cta-btn">
                  {current.cta_label}
                </Button>
              </a>
            )}
            <Button variant="outline" onClick={dismiss} data-testid="notif-dismiss-btn">Dismiss</Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
